import { get, post, put, deleteR } from '@/services/API';

export default {
  post: (obj) => post('/api/pension', obj),
  getAll: (params) => get(`/api/pension?${new URLSearchParams(params)}`),
  get: (id) => get(`/api/pension/${id}`),
  put: (obj) => put(`/api/pension/${obj._id}`, obj),
  delete: (id) => deleteR(`/api/pension/${id}`),
};
